export default function () {
 const buttons = document.querySelectorAll(".bio-button");
 const blocks = document.querySelectorAll("[data-bio]");
 if (buttons) {
  buttons.forEach(b => {
    b.addEventListener("click", (evt) => {
      const target = evt.target.getAttribute("data-target");
      blocks.forEach(bio => {
        const tag = bio.getAttribute("data-bio");
        buttons.forEach(b => {
          if (b === evt.target) {
            b.classList.add("selected");
          }else {
            b.classList.remove("selected");
          }
        });
        if (tag === target) {
          bio.classList.remove("hidden");
        }
        else {
          bio.classList.add('hidden');
        }

      })
    })

  });
 }
}